import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Rationale from "../components/Rationale";
import WorkProgramme from "../components/WorkProgramme";
import Technology from "../components/Technology";
import Roadmap from "../components/Roadmap";
import StudyMap from "../components/StudyMap";
import Partnerships from "../components/Partnerships";
import Team from "../components/Team";
import UpdatesPreview from "../components/UpdatesPreview";
import Closing from "../components/Closing";

const REDUCED = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function Home() {
  const [booted, setBooted] = useState(REDUCED);

  useEffect(() => {
    if (REDUCED) return undefined;
    const t = setTimeout(() => setBooted(true), 1750);
    return () => clearTimeout(t);
  }, []);

  return (
    <main data-testid="home-page">
      <AnimatePresence>
        {!booted && (
          <motion.div
            className="fixed inset-0 z-[100] bg-abyss flex flex-col items-center justify-center"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            data-testid="boot-loader"
          >
            <div className="font-mono text-[10px] tracking-[0.4em] text-polar mb-3">ARJUNA SPACE AI INDIA</div>
            <div className="font-display font-bold text-2xl sm:text-3xl text-ice tracking-[0.15em] uppercase">Arjuna Antarctica</div>
            <div className="mt-8 w-56 h-px bg-polar/15 relative overflow-hidden">
              <motion.div
                className="absolute inset-y-0 left-0 bg-mission"
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 1.4, ease: "easeInOut" }}
              />
            </div>
            <div className="mt-4 font-mono text-[9px] tracking-[0.3em] text-tech">63°S 059°W · INITIALISING ORBITAL LINK</div>
          </motion.div>
        )}
      </AnimatePresence>

      <Nav />
      <Hero booted={booted} />
      <Marquee />
      <Rationale />
      <WorkProgramme />
      <Technology />
      <Roadmap />
      <StudyMap />
      <Partnerships />
      <Team />
      <UpdatesPreview />
      <Closing />
    </main>
  );
}
